import React from 'react';
import {saveData} from '../actions/Screen';
import checkMark from '../../../../images/check_mark.png';
import {Button} from '../../../../components/Common/Buttons/Button';
import {textConst, texts, getLocalizedText} from '../../../../constants/TextConst';

export const PanelFooterButtons = ({closePanel, screensStore}) => {
    const handleSave = () => {
        saveData(screensStore, closePanel);
    };

    return (
        <div className="panel-bottom">
            <Button
                componentClasses="cancel-btn"
                onClick={closePanel}
                text={getLocalizedText(texts.cancel)}
            />
            <Button
                componentClasses="confirm-btn"
                onClick={handleSave}
                img={checkMark}
                alt={textConst.confirmAlt}
                text={getLocalizedText(texts.save)}
                labeled
                roundCorners
            />
        </div>
    );
};
